import { Model } from "@tailflow/laravel-orion/lib/model";

export class Role extends Model<{
  name: string;
  slug: string;
  resources?: any;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "roles";
  }
}
